import { useState } from "react";

const useExportData = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const exportAction = async (
    exportFunction: () => Promise<Blob>,
    fileName: string,
    format: string
  ): Promise<{ success: boolean }> => {
    setIsLoading(true);
    setError(null);

    try {
      const blob = await exportFunction();
      if (!blob || blob.size === 0) {
        throw new Error("Получен пустой файл");
      }

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${fileName}_export_${new Date().toISOString().split("T")[0]}.${format}`
      );

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(url);
      document.body.removeChild(link);

      return { success: true };
    } catch (err) {
      let errorMessage = "Неизвестная ошибка при экспорте";

      if (err instanceof Error) {
        errorMessage = err.message;
      } else if (typeof err === "string") {
        errorMessage = err;
      } else {
        console.error("Unexpected error type:", typeof err, err);
        errorMessage = "Неизвестная ошибка при экспорте";
      }

      setError(errorMessage);
      console.error("Export error:", err);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { error, isLoading, exportAction };
};

export default useExportData;
